import { makeAlignStyleSelector } from "@client/content/modules/Button";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import { ubsubscribe } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type UnsubscribeActionProps, type UnsubscribeFormData, type UnsubscribeMapProps } from "./component";
import { makeFieldsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const buttonStyleSelector = makeAlignStyleSelector(TargetSelector.Entity);
  const fieldsSelector = makeFieldsSelector();

  return (state: AppState, props: RootContainerProps): UnsubscribeMapProps => {
    const { status } = localStateSelector(state, props);
    return {
      ...props,
      buttonStyle: buttonStyleSelector(state, props),
      fields: fieldsSelector(state, props),
      status
    };
  };
};

export const mapDispatchToProps = (dispatch: any, props: RootContainerProps): UnsubscribeActionProps => ({
  unsubscribe: (data: UnsubscribeFormData) => {
    dispatch(ubsubscribe({ id: props.id, source: props.source, ...data }));
  }
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
